<template>
  <div id="canvasSizer" style="height: 100%">
    <div class="innerCanvasContainer" style="height: 100%" id="innerCanvasContainer">
      <canvas id="schema" class="schema" width="500" height="500" style="z-index: 1;"></canvas>
    </div>
  </div>
</template>

<script>
  import {fabric} from "fabric-with-gestures";
  import LaravelDateToJs from "../mixin/LaravelDateToJs";
  import helpers from "../../../constructor/mixins/helpers";
  import SetStatus from "./SetStatus";
  import FastCreateBooking from "./FastCreateBooking";
  import FabricHelper from "./mixins/FabricHelper";
  import CanvasTableHelper from "./mixins/CanvasTableHelper";

  //Disable context menu
  fabric.util.addListener(document.getElementsByClassName('upper-canvas')[0], 'contextmenu', function (e) {
    e.preventDefault();
  });

  fabric.Object.prototype.set({
    hasControls: false,
    hasBorders: false,
    hasRotatingPoint: false,
    selectable: false,
    selection: false
  });

  export default {
    props: {
      restaurantId: {
        type: [Number, String],
      },
    },
    components: {
      SetStatus,
      FastCreateBooking
    },
    mixins: [LaravelDateToJs, helpers,FabricHelper, CanvasTableHelper],
    mounted() {
      this.$store.dispatch('restaurantZones/loadZones', {
        restaurantId: this.restaurantId
      });
      this.$store.dispatch('restaurants/getRestaurant', {
        id: this.restaurantId
      }).then((data) => {
        this.restaurant = data.data
        this.loadReservationByTable()
      })
    },
    data() {
      return {
        canvas: null,
        allCanvasObjects:[],
        tables: [],
        restaurant: {}
      }
    },
    methods: {
      initApplication(){
        this.initCanvas();
        this.loadRestaurantSchema();
        if(!isMobile){
          this.setCanvasSizeByMaxCoords(this.canvas)
          this.setZoomFullScreen();
          this.handleDataTables(this.tables);
        }else{
          this.canvas.clear();
        }
      },
      loadReservationByTable() {
        axios.get('reservation/' + this.restaurantId + '/viewCurrentState')
          .then((data) => {
            this.tables = data.data.tables;
          }).then(() => {
          this.initApplication();
        })
      },
      initCanvas() {
        this.canvas = new fabric.Canvas('schema', {
          containerClassName: 'schema',
          allowTouchScrolling: true,
          selectable: false,
          selection: false,
          controlsAboveOverlay: true,
          renderOnAddRemove: false
        });
      },
      getTableIdFromObject(object){
        return object.my.id
      },
      isTableObject(object){
        return object && object.my && object.my.id
      },
      relateObjectToTable(object){
        object.my.left = object.left
        object.my.top = object.top
        this.tables[this.getTableIdFromObject(object)].canvasObject = object;
      },
      loadRestaurantSchema(){
        this.canvas.loadFromJSON(this.restaurant.schema, () => {}, (o, object) => {
          this.isTableObject(object) ? this.relateObjectToTable(object) : null;
        })
      },
      filterByZone(zones) {
        //   this.selectionTables = [];
        // this.$store.commit('map/setSelectionTables', [])
        this.canvasSetZoom(this.canvas, 1)
        this.canvas.clear();
        _.map(this.tables, (o) => {
          if(o.canvasObject && o.canvasObject.my && o.canvasObject.my.left){
            o.canvasObject.set({
              left : o.canvasObject.my.left,
              top : o.canvasObject.my.top
            });
          }
          if (zones.indexOf(o.zone_id) !== -1) {
            this.canvas.add(o.canvasObject)
          }
        })
        this.resetData();
        this.calculateFarthestPoint(this.canvas);
        this.objectOffsetToLeft()
        this.resetData();
        this.setCanvasSizeByMaxCoords(this.canvas)
        _.map(this.tables, (o) => {
          if (zones.indexOf(o.zone_id) !== -1) {
            this.handleDataTable(o)
          }
        })
        this.setZoomFullScreen()
        this.canvas.renderAll()
      },
      objectOffsetToLeft(){
        this.canvas._objects.map(object => {
          let left = object.left  - this.nearestPoint.x
          let top =  object.top  - this.nearestPoint.y
          object.set({
            top,left
          });
          object.setCoords()
        })
      }
    }
  }
</script>

<style scoped>

</style>
